<template>
  <div class="mm-page-main">
    <el-form ref="form" :model="form" :rules="rules" label-width="130px" label-position="left">
      <div class="page-header">
      </div>
      <el-tabs v-model="tabsindex" @tab-click="changetabs">

        <el-tab-pane label="賬戶信息" name="0">
          <div class="radio-group-box">
            <div>
              <el-radio-group :disabled="true" v-model="area">
                <el-radio-button label="0">港幣</el-radio-button>
                <el-radio-button label="1">人民幣</el-radio-button>
                <el-radio-button label="2">外幣</el-radio-button>
              </el-radio-group>
            </div>
          </div>
          <hkbankform :form="form" v-if="area==0"></hkbankform>
          <cnbankform :form="form" v-if="area==1"></cnbankform>
          <enbankform :form="form" v-if="area==2"></enbankform>

        </el-tab-pane>
        <el-tab-pane label="戶主信息" name="1">
          <accountholder :form="form"></accountholder>
        </el-tab-pane>
        <el-tab-pane label="電話卡" name="2">
          <accountphone :form="form"></accountphone>
        </el-tab-pane>

      </el-tabs>
      <div class="form-submit">
        <el-button @click="formsubmit('form')" type="primary">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import hkbankform from './HKBankForm.vue';
import cnbankform from './CNBankForm.vue';
import enbankform from './ENBankForm.vue';
import accountholder from './AccountHolder.vue';
import accountphone from './AccountPhone.vue';

export default {
  props: ['account_id'],
  components: {
    hkbankform,
    cnbankform,
    enbankform,
    accountholder,
    accountphone,

  },
  data () {
    return {
      form: {
        area: 0,
        account_name: '',
        account_num_format: '',
        currency_id: 2,
        status: true,
        hkbank_id: 0,
        bankname: '',
        balance: '0.00',
        holder: {
          code: '',
          name: '',
          card: '',
          phone: '',
          holderman: '',
          holder_phone: '',
          agentman: '',
          agent_phone: '',
          cardtype: '0',
          usb: '0',
          buytype: '0',
          endtime: '',
          tipstime: '',
          startrent_time: '',
          endrent_time: ''
        },
        phones: {
          code: '',
          phone: '',
          service: '',
          endtime: '',
          money: ''
        }

      },
      rules: {

        account_num: [{
          required: true,
          message: '請填寫賬號號碼',
        }, {
          pattern: /^[0-9\-]+$/,
          message: '只能輸入數字和-'
        }],
        account_name: [{
          required: true,
          message: '請填寫賬號持有人名稱',
        }],
        swift_code: [{
          required: true,
          message: '請填寫SWIFT CODE',
        }],
        country_id: [{
          required: true,
          message: '請選擇國家/地區',
        }
        ],
        bankname: [{
          required: true,
          message: '請選擇或填寫銀行名稱',
          trigger: 'change'
        }],
        balance: [{
          required: true,
          message: '請填寫餘額',
        }, {
          pattern: /^[0-9\.]+$/,
          message: '只能輸入整數和小數'
        }],
        'holder.name': [{
          required: true,
          message: '請輸入戶主姓名',
        }
        ],
        'holder.card': [{
          required: true,
          message: '請輸入身份證卡號',
        }
        ],
        'holder.phone': [{
          required: true,
          message: '請填寫電話號碼',
        }, {
          pattern: /^[0-9,，]+$/,
          message: '只能輸入數字和“,”'
        }],
        'holder.holderman': [],
        'holder.holder_phone': [{
          pattern: /^[0-9,，]+$/,
          message: '只能輸入數字和“,”'
        }],
        'holder.agentman': [],
        'holder.agent_phone': [{
          pattern: /^[0-9,，]+$/,
          message: '只能輸入數字和“,”'
        }],

        'phones.phone': [{
          required: true,
          message: '請填寫電話號碼',
        }, {
          pattern: /^[0-9]+$/,
          message: '只能輸入數字'
        }],
        'phones.endtime': [{
          required: true,
          message: '請選擇到期日期',
        }],
        'phones.money': [{
          required: true,
          message: '請填寫餘額',
        }, {
          pattern: /^[0-9\.]+$/,
          message: '只能輸入數字和小數'
        }]


      },
      tabsindex: '0',
      area: '',
      bankform: 'hkbankform'
    };
  },
  methods: {
    getdata () {
      let account_id = this.account_id;
      this.post('/api/bank/getaccountinfo', { account_id }).then(response => {
        this.area = response.area;
        if (this.area == 0) {
          this.bankform = 'hkbankform';
        } else if (this.area == 1) {
          this.bankform = 'cnbankform';
        } else {
          this.bankform = 'enbankform';
        }
        if (response.status == 0) {
          response.status = true;
        } else if (response.status == 1) {
          response.status = false;
        }
        response.account_num_format = this.addSpace(response.account_num);
        this.form = response;
      }).catch(error => {
        console.log(error);
      });
    },
    changetabs (tab, event) {

    },
    pageback () {
      this.$router.go(-1);
    },
    formsubmit (form) {

      this.$refs[form].validate((valid) => {
        if (valid) {
          this.form.area = this.area;
          let data = this.form;

          this.loading = true;
          this.post('/api/bank/bank_account_edit', {
            data: data
          }).then((res) => {

            if (res == 'success') {
              this.$message({
                showClose: true,
                message: '修改銀行賬號成功！',
                type: 'success',
                onClose: (() => {
                })
              });
            } else {
              this.$message({
                showClose: true,
                message: '修改銀行賬號失敗，請重試！',
                type: 'error',

              });
            }

            this.loading = false;
          }).catch((err) => {
            this.loading = false;
            console.log(err)
          });
        } else {
          this.$message({
            showClose: true,
            message: '請填寫賬戶信息，戶主信息，電話卡等必填字段後提交！',
            type: 'error',

          });
        }
      });
    },

  },
  created () {
    this.getdata();
  }

};
</script>
<style scoped>
.el-tabs__content {
  overflow: auto;
}
</style>
